{
    "HeaderSidebar_ExpandMenu": "Expandir Menu (Ctrl + ])",
    "HeaderSidebar_CollapseMenu": "Recolher menu (Ctrl + [)",
    "HeaderSidebar_PinMenu": "Menu de Pinos Expandido",
    "HeaderSidebar_UnpinMenu": "Desafixar menu",
    "NAME": "HeaderSidebar"
}